import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "rounded-full bg-green-700 p-2 w-8 mr-2"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_WarningIcon = _resolveComponent("WarningIcon")
  const _component_CheckIcon = _resolveComponent("CheckIcon")

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.getTypeStyles(_ctx.type), "rounded mx-2 sm:mx-auto px-4 py-3 border mb-4 flex flex-row justify-center items-center"],
    role: "alert"
  }, [
    (_ctx.type === 'warn')
      ? _createVNode(_component_WarningIcon, {
          key: 0,
          class: "w-6 h-6 text-yellow-900 mr-4"
        })
      : _createCommentVNode("", true),
    (_ctx.type === 'success')
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_CheckIcon, { class: "w-4 h-4 text-white mr-4" })
        ]))
      : _createCommentVNode("", true),
    _createVNode("span", null, _toDisplayString(_ctx.message), 1)
  ], 2))
}